import React, { useState, useRef, useEffect } from 'react';
import '../../styles/global.css';
import '../../styles/variables.css';
import './FaisalNavbar.css';
import { Link, useNavigate } from 'react-router-dom';
import logo from '../../assets/logos/logo.png';

const FaisalNavbar = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const menuRef = useRef(null);
  const hamburgerRef = useRef(null);
  const navigate = useNavigate();

  const toggleMobileMenu = () => {
    setMobileMenuOpen(prev => !prev);
  };

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
    setMobileMenuOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        menuRef.current &&
        !menuRef.current.contains(event.target) &&
        hamburgerRef.current &&
        !hamburgerRef.current.contains(event.target)
      ) {
        setMobileMenuOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <nav className="navbar">
      <div className="navbar-logo" onClick={() => navigate('/')}>
        <img src={logo} alt="Skript Logo" />
        <span>Skript</span>
      </div>

      <div className="navbar-links">
        <Link to="/#services" className="navbar-link" onClick={() => scrollToSection('services')}>
          Services
        </Link>
        <Link to="/#products" className="navbar-link" onClick={() => scrollToSection('products')}>
          Why Us
        </Link>
        <Link to="/more_products" className="navbar-link">
          Products
        </Link>
        <Link to="/project_prompt" className="navbar-link">
          AI Quotation
        </Link>
        <Link to="/#footer" className="navbar-link" onClick={() => scrollToSection('footer')}>
          More
        </Link>
      </div>
<div className="navbar-actions">
  <button
    className="navbar-button"
    onClick={() => navigate('/project_prompt')}
  >
    Get Started
  </button>
</div>

      <button
        ref={hamburgerRef}
        className="navbar-hamburger"
        onClick={toggleMobileMenu}
      >
        {mobileMenuOpen ? '✕' : '☰'}
      </button>

      {mobileMenuOpen && (
        <div ref={menuRef} className="navbar-mobile-menu active">
          <Link to="/#services" className="navbar-link" onClick={() => scrollToSection('services')}>
            Services
          </Link>
          <Link to="/#products" className="navbar-link" onClick={() => scrollToSection('products')}>
            Why Us
          </Link>
          <Link to="/more_products" className="navbar-link">
            Products
          </Link>
          <Link to="/project_prompt" className="navbar-link">
            AI Quotation
          </Link>
          <Link to="/#footer" className="navbar-link" onClick={() => scrollToSection('footer')}>
            More
          </Link>
          <button
            className="navbar-button"
            onClick={() => {
              navigate('/project_prompt');
              setMobileMenuOpen(false);
            }}
          >
            Get Started
          </button>
        </div>
      )}
    </nav>
  );
};

export default FaisalNavbar;
